import Vue from "vue"
import "vuetify/dist/vuetify.min.css"
import ErpAapp from "../erp_app.vue"
import router from "../erp_router.js"
import store from "../erp_store/erp_store"
// import metaMixin from "./erp_src/helper/metaMixin"
import Vuetify from "vuetify"
import dayjs from "dayjs"
import colors from "vuetify/lib/util/colors"
import "@mdi/font/css/materialdesignicons.css"
import "../erp_src/stylesheet/global.scss"
import "../erp_src/stylesheet/shared/form.scss"

dayjs.locale("ja")
Vue.prototype.$dayjs = dayjs

store.dispatch("auth/autoLogin")
Vue.use(Vuetify)
// Vue.mixin(metaMixin)
const vuetify = new Vuetify({
	icons: {
		iconfont: "mdi",
		iconfont: "mdiSvg",
	},
	theme: {
		themes: {
			dark: {
				primary: "#09194F",
				secondary: "#00808A",
				red: colors.red.accent4,
				white: "#fefefe",
				gray: "#1a1a1a",
			},
			light: {
				primary: "#09194F",
				secondary: "#00808A",
				red: colors.red.accent4,
				white: "#fefefe",
				process: {
					scheduled: colors.lightGreen.lighten3,
					planned: colors.lightBlue.lighten3,
					scheduled: colors.lightGreen.lighten3,
					ongoing: colors.orange.lighten2,
					interruption: colors.brown.lighten3,
					completion: colors.blueGrey.lighten3,
					canceled: colors.grey.lighten1,
					schedule_confirmed: colors.lightGreen.lighten3,
					schedule_arranging: colors.lightBlue.lighten3,
					schedule_noting: colors.orange.lighten2,
				},
				rubber_process: {
					requested: colors.lightBlue.lighten3,
					scheduled: colors.lightGreen.lighten3,
					ongoing: colors.orange.lighten2,
					interruption: colors.brown.lighten3,
					completed: colors.blueGrey.lighten3,
					canceled: colors.grey.lighten1,
				},
				load_factor: {
					order_received: colors.orange.lighten2,
					shipped: colors.blueGrey.lighten3,
					situation_a: colors.lightGreen.lighten3,
					situation_b: colors.lightBlue.lighten3,
				},
			},
		},
	},
	breakpoint: {
		thresholds: {
			xs: 600,
			sm: 960,
			md: 1264,
			lg: 1904,
		},
	},
})

// Vue.config.productionTip = false
document.addEventListener("DOMContentLoaded", () => {
	const el = document.body.appendChild(document.createElement("hello"))

	const app = new Vue({
		router,
		vuetify,
		store,
		el,
		render: (h) => h(ErpAapp),
	}).$mount("#erp_app")
})
